// TODO: this file appears to be an exact duplicate of SceneDropHandler.js - DEV-4316 describes this effort.
define((require) => {
    "use strict";

    const WidgetTypes = require("shared/ui/experience/widgets/WidgetTypes");
    const $ = require("jquery");
    const _ = require("underscore");
    const GeneralFunctions = require("util/GeneralFunctions");


    return {

        ADD_UPLOAD_BARS: "add:upload:bars",

        WIDGET_OPTIONS: {
            "previous-scene": {
                width: 50,
                height: 50
            },
            "next-scene": {
                width: 50,
                height: 50
            },
            "text-enhanced": {
                width: 250,
                disableCentering: true
            },
            "youtube": {
                width: 240,
                height: 135
            },
            "line": {
                height: 25
            },
            "link": {
                width: 128,
                height: 128
            },
            "html": {
                width: 128,
                height: 128
            },
            "shape": {
                width: 128,
                height: 128
            },
            "embed": {
                width: 128,
                height: 128
            },
            "dynamic-product": {
                width: 100,
                height: 100
            }
        },

        /**
         * Given a drop event, computes the offset coordinates for it.
         *
         * @param {Number} pageX - Position of the mouse pointer, relative to the left edge of the document
         * @param {Number} pageY - Position of the mouse pointer, relative to the top edge of the document.
         * @param {Object} offset - Scene Editor offset.
         * @param {Number} scale - Scene Editor scale factor.
         * @returns {Object} Coordinates, as an object with x and y properties.
         * @private
         */
        getOffsetCoordinates: function(pageX, pageY, offset, scale) {
            return ({
                x: (pageX - offset.left) / scale,
                y: (pageY - offset.top) / scale
            });
        },

        getOffsetCoordinatesXY: function(pageX, pageY, offset, scale) {
            return ({
                x: (pageX - offset.left) / scale.x,
                y: (pageY - offset.top) / scale.y
            });
        },

        /**
         * Takes a widget type and some options and creates a new widget.
         *
         * @param {Object} experienceSize   The experience size.
         * @param {Object} widgetDescriptor The widget descriptor.
         * @param {Object} options          Set of options.
         * @return {AbstractWidgetModel}    The created Widget.
         * @private
         */
        createWidget: GeneralFunctions.curry((experienceSize, widgetDescriptor, options) => {
            const widget = new widgetDescriptor.modelClass(options);

            if (_.isFunction(widgetDescriptor.initializer)) {
                widgetDescriptor.initializer(widget, experienceSize);
            }

            return widget;
        }),

        /**
         * Creates a function that takes a minimal options and extends it with a
         * position and updates its width and height if they exist.
         *
         * @param {Number} experienceSize
         * @param {Object} point
         * @return {Function}
         * @private
         */
        makeExtendOptions: (experienceSize, point) => {
            return (opt) => {
                if (!opt) {
                    opt = {};
                }
                const options = _.clone(opt);

                options.left = (point.x / experienceSize.width * 100);
                options.top = (point.y / experienceSize.height * 100);

                // convert width and height to percentage
                if (options.width) {
                    options.width = options.width / experienceSize.width * 100;

                    if (!opt.disableCentering) {
                        options.left -= options.width / 2;
                    }
                }

                if (options.height) {
                    options.height = options.height / experienceSize.height * 100;

                    if (!opt.disableCentering) {
                        options.top -= options.height / 2;
                    }
                }
                return options;
            };
        },
        /**
         * Creates an options object based on a imageModel
         *
         * @param {Object} imageModel
         * @return {Object}
         * @private
         */
        createImageOptions: (imageModel) => {
            const options = {
                altText: imageModel.get("altText"),
                imageId: imageModel.get("id"),
                height: imageModel.get("height"),
                width: imageModel.get("width"),
                originalImageHeight: imageModel.get("height"),
                originalImageWidth: imageModel.get("width"),
                src: imageModel.get("url"),
                supportsResize: imageModel.get("supportsResize")
            };

            if (imageModel.get("sourceType")) {
                options.sourceType = imageModel.get("sourceType");
            }

            return options;
        },

        /**
         * Takes an array of uploading ImageModels, and returns a promise that
         * resolves once all imageModels have finished.
         *
         * @param {Array} imageModels  - Array of <tt>ImageModel</tt>'s
         * @return {Promise}        - Promise that resolves with uploaded
         *                            ImageModels (failed uploads are
         *                            rejected)
         */
        allImagesUploaded: (imageModels) => {
            let numOfFinishedUploads = 0;

            const numOfImageModels = imageModels.length;
            const deferred = $.Deferred();

            const increaseNumberOfUploads = () => {
                let uploadedModels;

                numOfFinishedUploads++;

                if (numOfFinishedUploads >= numOfImageModels) {
                    uploadedModels = _.reject(imageModels, (model) => {
                        return model.get("uploadFailed");
                    });

                    deferred.resolve(uploadedModels);
                }
            };

            _.each(imageModels, (imageModel) => {
                imageModel.once("change:uploading change:uploadfailed", increaseNumberOfUploads);
            });

            return deferred.promise();
        },

        getWidgetDescriptor: (dataTransfer) => {
            try {
                const data = JSON.parse(dataTransfer.getData("Text"));

                return {
                    data: data,
                    descriptor: WidgetTypes.lookup(data.type, true) // true = silent -> "descriptor" can be falsey.
                };
            } catch (e) { // only on parse errors
                return {};
            }
        }
    };
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/CreateWidgetHelper.js